<script>
	import ImageOptimiser from '$lib/components/common/ImageOptimiser.svelte';
	import * as SERVICES from '$ravioli/lib/assets/images/services/index';
	import redRightArrow from '$ravioli/lib/assets/icons/right-arrow-red.svg';
	let services = [
		{
			image: SERVICES.services1,
			title: 'Nutrition Counselling',
			desc: 'During a consultation, our highly trained and certified nutritionists initially assess client’s current medical conditions, eating habits and understand...',
			link: 'our-services/#nutrition-counselling'
		},
		{
			image: SERVICES.services2,
			title: 'Fitness Counselling',
			desc: 'Our fitness experts provide consultation on basic fitness and exercise program design for health and weight management and/or athletic performance...',
			link: 'our-services/#fitness-counselling'
		},
		{
			image: SERVICES.services3,
			title: 'Vitamin & Supplementation Counselling',
			desc: 'We are a team of subject matter experts in nutrition and fitness. We believe that modern drugs are just band aids and often lead to nasty side effects and...',
			link: 'our-services/#vitamin-supplementation-counselling'
		},
		{
			image: SERVICES.services5,
			title: 'Food & Grocery Selection',
			desc: 'Food and grocery shopping might seem like one of the most easiest errands for most of us. But our journey to safety and health should start with...',
			link: 'our-services/#food-grocery-selection'
		},
		{
			image: SERVICES.services4,
			title: 'Workplace Wellness',
			desc: 'Ravioli Team also offers workplace wellness programs/workshops to corporates to support employees as they adopt and sustain behaviors...',
			link: 'our-services/#workplace-wellness'
		},
		{
			image: SERVICES.services6,
			title: 'Fitfood Catering for Events',
			desc: 'Whether you are planning a large event or an intimate gathering, are looking for a full, or need a great caterer for your office functions, Ravioli fit...',
			link: 'our-services/#fitfood-catering-events'
		}
	];
</script>

<section class="font-roboto mx-auto max-w-5xl px-4 py-5 md:py-11">
	<div class="flex flex-col gap-4">
		<p class="title-underline relative mx-auto max-w-fit text-xl font-medium uppercase md:text-2xl">
			Our Services
		</p>
		<p class="text-center text-base max-w-[860px] mx-auto">
			Our fitness experts provide consultation on basic fitness and exercise program design for
			health and weight management and/or athletic performance.
		</p>
		<ul class="mt-8 flex flex-col flex-wrap gap-8 md:flex-row md:justify-center">
			{#each services as service}
				<li class="services-list relative overflow-hidden">
					<div class="relative flex gap-3 md:rounded-[18px] lg:overflow-hidden">
						<div class="relative flex-none">
							<div class="overlay absolute inset-0 rounded-[18px] z-[1]"></div>
							<ImageOptimiser
								src={service.image}
								alt="services images"
								imageSourceType="internal"
								classes={{
									container:
										'max-w-[150px] max-h-[180px] md:max-w-[280px] md:max-h-[350px] md:rounded-[18px] rounded-lg overflow-hidden',
									image: 'rounded-lg w-full h-full object-cover '
								}}
							/>
						</div>
						<div class="flex flex-col gap-0.5 md:absolute md:bottom-6 md:left-6 md:max-w-[220px]">
							<p class="services-title break-words text-sm font-medium md:text-2xl md:text-white">
								{service.title}
							</p>
							<div class="services-desc-container z-[2]">
								<p class="services-desc text-xs/5 md:overflow-hidden md:text-base md:text-white">
									{service.desc}
								</p>
								<a
									href={service.link}
									class="mt-2 flex items-center gap-1 md:justify-center md:rounded-lg md:bg-[#ED292D] md:py-3"
								>
									<span class="text-sm text-[#ED292D] md:text-white">Learn more</span>
									<img
										src={redRightArrow}
										alt="red right arrow"
										class="filter md:brightness-[100]"
									/>
								</a>
							</div>
						</div>
					</div>
				</li>
			{/each}
		</ul>
	</div>
</section>

<style>
	@media screen and (min-width: 768px) {
		.services-desc {
			display: -webkit-box;
			max-width: 200px;
			line-clamp: 5;
			-webkit-line-clamp: 5;
			-webkit-box-orient: vertical;
			overflow: hidden;
		}
		.services-desc {
			height: 120px;
		}
		.services-desc-container {
			height: 0px;
			overflow: hidden;
			transition: all 0.3s ease-in-out;
		}
		.services-list:hover .services-desc-container {
			height: 178px;
			transition: all 0.3s ease-in-out;
		}
		.overlay {
			opacity: 0;
			transition: all 0.3s ease-in-out;
			pointer-events: none;
			background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.8) 100%);
		}
		.services-list:hover .overlay {
			transition: all 0.3s ease-in-out;
			opacity: 1;
			pointer-events: auto;
		}
		.services-title {
			transition: all 0.3s ease-in-out;
		}
		.services-list:hover .services-title {
			opacity: 0;
			transition: all 0.3s ease-in-out;
		}
	}
</style>
